import React, { Fragment, memo } from 'react';
import { FormattedMessage } from 'react-intl';
import core from '@gin-betting/core';
import cn from 'classnames';
import cd from 'debug';
import { capitalize } from 'lodash';

import globalMessages from 'messages';
import LiveLabel from '../LiveLabel';

import './dateTime.scss';

const { formatTimeAndDate } = core.utils;
const debug = cd('components:DateTime');

interface Props {
    isLiveMatch: boolean;
    startTime: string;
}

const DateTime: React.FC<Props> = props => {
    debug('render', props);

    const { startTime, isLiveMatch } = props;
    const { isToday, date, time } = formatTimeAndDate(startTime);

    return (
        <div
            styleName={cn('container', {
                'is-today': isToday,
            })}
            className={cn('__app-DateTime-container')}
        >
            {isLiveMatch ? (
                <LiveLabel />
            ) : (
                <Fragment>
                    <div styleName="date" className="__app-DateTime-date">
                        {isToday ? time : capitalize(date)}
                    </div>
                    <div styleName="time" className="__app-DateTime-time">
                        {isToday ? (
                            <FormattedMessage {...globalMessages.todayText} />
                        ) : (
                            time
                        )}
                    </div>
                </Fragment>
            )}
        </div>
    );
};

export default memo(DateTime);
